import Icon from '@components/v2/ui/Icon/Icon';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Card, CardActionArea, CardMedia } from '@mui/material';
import { CirclePlay, File } from 'lucide-react';
import FileCardHeader from './components/FileCardHeader/FileCardHeader';
import { FileCardProps } from './fileCard.types';

const FileCard = ({
  fileName,
  mediaType,
  url,
  onRemove,
  onEdit,
  onClick,
  isSquare = false,
  backgroundShade = 100,
  headerOpacity,
  isFileNameHidden,
  isMediaIconHidden,
  mediaAspectRatio,
}: FileCardProps) => {
  const extension = fileName.includes('.') ? fileName.split('.').pop() : '';

  const hasOnClick = !!onClick;
  const isVideo = mediaType === 'VIDEO';
  const showPlayToVideo = isVideo && hasOnClick;
  const isImageOrVideo = mediaType === 'IMAGE' || isVideo;

  return (
    <Card
      elevation={0}
      sx={{
        width: '100%',
        overflow: 'hidden',
        borderRadius: '8px',
        position: 'relative',
        aspectRatio: isSquare ? '1 / 1' : '4 / 3',
        boxSizing: 'border-box',
        backgroundColor: (theme) => theme.palette.grey[backgroundShade],
      }}
    >
      <FileCardHeader
        fileName={fileName}
        isImageOrVideo={isImageOrVideo}
        opacity={headerOpacity}
        isFileNameHidden={isFileNameHidden}
        isMediaIconHidden={isMediaIconHidden}
        onRemove={onRemove}
        onEdit={onEdit}
      />

      <CardActionArea disabled={!hasOnClick} onClick={onClick} sx={{ height: '100%' }}>
        {isImageOrVideo ? (
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              position: 'relative',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {showPlayToVideo && (
              <Box sx={{ position: 'absolute', zIndex: 1, display: 'flex' }}>
                <Icon icon={CirclePlay} size="xl" />
              </Box>
            )}

            <CardMedia
              image={url}
              alt={`Media content ${fileName}`}
              component={isVideo ? 'video' : 'img'}
              sx={{
                width: '100%',
                height: mediaAspectRatio ? 'auto' : '100%',
                aspectRatio: mediaAspectRatio,
                objectFit: 'cover',
              }}
              onError={() => {
                // TODO: PODEMOS CRIAR UM HANDLE MAIS ELABORADO PARA ERROS DE CARREGAMENTO
                console.error(`Error loading media: ${fileName}`);
              }}
            />
          </Box>
        ) : (
          <Box
            sx={{
              gap: 0.5,
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Icon icon={File} size="xl" />

            <Typography variant="body2">.{extension}</Typography>
          </Box>
        )}
      </CardActionArea>
    </Card>
  );
};

export default FileCard;
